// import React, { useState, useEffect } from "react";
// import { Card, CardBody, Row, Col } from "reactstrap";
// import "./technologyCards.css";
// import { useNavigate } from "react-router-dom";
// // import StudentDetailsCard from "./StudentDetailsCard";

// const TechnologiesCards = ({ course_id, technologies, course_name }) => {
//   const [selectedTechnology, setSelectedTechnology] = useState(null);
//   const navigate = useNavigate();

//   console.log("Technologies received:", technologies);

//   const colorGradients = [
//     "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)",
//     "linear-gradient(135deg, #ff9966 0%, #ff5e62 100%)",
//     "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)",
//     "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     "linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)",
//   ];


//   useEffect(() => {
//     if (selectedTechnology) {
//       navigate(`/add-course-payment/${course_id}/${selectedTechnology.technology_id}`);
//     }
//   }, [selectedTechnology]);

//   return (
//     <React.Fragment>
//       <div className="text-center mb-4 mt-4">
//         <h2 className="fw-bold text-primary text-uppercase">
//           Technologies for {course_name}
//         </h2>
//         <p className="text-muted mb-0">
//           Click on a technology card below to get student Fee details.
//         </p>
//       </div>

//       {/* Technologies Grid */}
//       <Row className="g-4">
//         {technologies.map((tech, index) => (
//           <Col
//             xl={3}
//             lg={3}
//             md={4}
//             sm={6}
//             xs={12}
//             key={index}
//             onClick={() => tech.status === 1 && setSelectedTechnology(tech)}
//             style={{ pointerEvents: tech.status === 0 ? "none" : "auto" }}
//           >
//             <Card
//               className={`tech-card border-0 ${tech.status === 0 ? "card-disabled" : ""}`}
//               style={{
//                 background: colorGradients[index % colorGradients.length],
//                 color: "white",
//                 borderRadius: "12px",
//                 cursor: tech.status === 0 ? "not-allowed" : "pointer",
//                 boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
//                 transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                 height: "100%",
//               }}
//             >
//               <CardBody className="p-3">

//                 {/* === TOP ROW === */}
//                 <div className="d-flex align-items-center justify-content-between">

//                   {/* ICON */}
//                   <div
//                     style={{
//                       backgroundColor: "rgba(255,255,255,0.15)",
//                       borderRadius: "15px",
//                       padding: "8px",
//                       width: "70px",
//                       height: "70px",
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                     }}
//                   >
//                     <img
//                       width={50}
//                       height={50}
//                       src={`${process.env.REACT_APP_BACKEND_IMAGE_URL}technology-icons/${tech.technology_icon}`}
//                       alt={tech.technology_name}
//                     />
//                   </div>

//                   {/* NAME / PROGRAM / STATUS */}
//                   <div className="flex-grow-1 mx-3">
//                     <h6
//                       className="fw-bold text-uppercase text-white mb-1"
//                       style={{ fontSize: "14px", lineHeight: "1.2" }}
//                     >
//                       {tech.technology_name}
//                     </h6>

//                     <p className="text-white-50 mb-1" style={{ fontSize: "12px" }}>
//                       {tech.program_name}
//                     </p>

//                     {tech.status === 0 ? (
//                       <span className="badge bg-danger">Inactive</span>
//                     ) : (
//                       <span className="badge bg-success">Active</span>
//                     )}
//                   </div>

//                   {/* === SEATS BOX ON THE RIGHT === */}
//                   <div
//                     style={{
//                       backgroundColor: "rgba(0,0,0,0.30)",
//                       borderRadius: "10px",
//                       padding: "6px 10px",
//                       minWidth: "95px",
//                       textAlign: "center",
//                     }}
//                   > <p className="m-0 mb-1">Seats</p>
//                     <p className="mb-1 fw-bold text-white" style={{ fontSize: "12px" }}>
//                       Avail: <span className="">{tech.seats_available}</span>
//                     </p>
//                     <p className="mb-0 fw-bold text-white" style={{ fontSize: "12px" }}>
//                       Paid: <span>{tech.seats_filled}</span>
//                     </p>
//                   </div>
//                 </div>

//               </CardBody>
//             </Card>
//           </Col>
//         ))}
//       </Row>


//     </React.Fragment>
//   );
// };

// export default TechnologiesCards;



import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import "./technologyCards.css";
import { useNavigate } from "react-router-dom";
// import StudentDetailsCard from "./StudentDetailsCard";

const TechnologiesCards = ({ course_id, technologies, course_name }) => {
  const [selectedTechnology, setSelectedTechnology] = useState(null);
  const navigate = useNavigate();

  console.log("Technologies received:", technologies);

  const colorGradients = [
    "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)",
    "linear-gradient(135deg, #ff9966 0%, #ff5e62 100%)",
    "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)",
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    "linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)",
  ];

  useEffect(() => {
    if (selectedTechnology) {
      navigate(`/add-course-payment/${course_id}/${selectedTechnology.technology_id}`);
    }
  }, [selectedTechnology]);

  return (
    <React.Fragment>
      <div className="text-center mb-4 mt-4">
        <h2 className="fw-bold text-primary text-uppercase">
          Technologies for {course_name}
        </h2>
        <p className="text-muted mb-0">
          Click on a technology card below to get student Fee details.
        </p>
      </div>

      {/* Technologies Grid */}
      <Row className="g-4">
        {technologies.map((tech, index) => (
          <Col
            xl={3}
            lg={3}
            md={4}
            sm={6}
            xs={12}
            key={index}
            onClick={() => tech.status === 1 && setSelectedTechnology(tech)}
            style={{ pointerEvents: tech.status === 0 ? "none" : "auto" }}
          >
            <Card
              className={`tech-card border-0 ${tech.status === 0 ? "card-disabled" : ""}`}
              style={{
                background: colorGradients[index % colorGradients.length],
                color: "white",
                borderRadius: "12px",
                cursor: tech.status === 0 ? "not-allowed" : "pointer",
                boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                height: "100%",
              }}
            >
              <CardBody className="p-3">

                {/* === TOP ROW === */}
                <div className="tech-card-top">

                  {/* ICON */}
                  <div className="tech-card-icon">
                    <img
                      src={`${process.env.REACT_APP_BACKEND_IMAGE_URL}technology-icons/${tech.technology_icon}`}
                      alt={tech.technology_name}
                    />
                  </div>

                  {/* NAME / PROGRAM / STATUS */}
                  <div className="tech-card-info">
                    <h6 className="fw-bold text-uppercase text-white mb-1">
                      {tech.technology_name}
                    </h6>

                    <p className="program-name mb-1">
                      {tech.program_name}
                    </p>

                    {tech.status === 0 ? (
                      <span className="badge bg-danger">Inactive</span>
                    ) : (
                      <span className="badge bg-success">Active</span>
                    )}
                  </div>

                  {/* === SEATS BOX ON THE RIGHT === */}
                  <div className="tech-card-seats">
                    <p className="m-0 mb-1">Seats</p>
                    <p className="mb-1 fw-bold text-white" style={{ fontSize: "12px" }}>
                      Avail: <span>{tech.seats_available}</span>
                    </p>
                    <p className="mb-0 fw-bold text-white" style={{ fontSize: "12px" }}>
                      Paid: <span>{tech.seats_filled}</span>
                    </p>
                  </div>
                </div>

              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

    </React.Fragment>
  );
};

export default TechnologiesCards;
